import { getRequestData } from '@/utils';
import cloneDeep from 'lodash/cloneDeep';
import {
  qryDisconnectionReasonBsnl,
  terminationBsnl,
} from '@/pages/Disconnection/services/disconnection';

const defaultState = {
  step: 0, // 拆机的步骤
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  reasonList: [],
  operationDetailsData: {}, // 存储第四步数据
  searchCustInfo: {},
  custValueMap: {},
};

export default {
  namespace: 'disconnection',
  state: cloneDeep(defaultState),
  effects: {
    *qryDisconnectionReasonBsnl({ payload }, { call, put }) {
      const response = yield call(qryDisconnectionReasonBsnl, payload);
      const { orderReasonDtoList = [] } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { reasonList: orderReasonDtoList },
      });
    },
    // 拆机
    *terminationBsnl({ payload }, { call }) {
      const response = yield call(terminationBsnl, payload);
      return getRequestData(response, false);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
